/** Internal paths a signed-out visit may return to. Rejects open redirects. */
export function safeNextPath(value: string | null): string | null {
  if (!value?.startsWith("/") || value.startsWith("//") || value.includes("\\")) return null;
  const path = value.split(/[?#]/, 1)[0] ?? "";
  if (
    path !== "/app" &&
    path !== "/onboarding" &&
    path !== "/continue" &&
    path !== "/integrations/setup" &&
    !path.startsWith("/app/")
  ) {
    return null;
  }
  return value;
}
